import { MODAL_NO_BLUR } from '@apps-common/config/modal'
import { useWindowDimensions } from './useWindowDimensions'

export const useModalNoBlur = () => {
  const { isMobile, isTablet } = useWindowDimensions()

  return !isMobile && !isTablet ? MODAL_NO_BLUR : {}
}
